import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../contexts/LanguageContext';

const SITE_URL = 'https://anyelo-elite-1.preview.emergentagent.com';
const OG_IMAGE = 'https://anyelo-elite-1.preview.emergentagent.com/og-image.jpg';
const SITE_NAME = 'Anyelo Elite';

export default function SEO({ title, description, path = '/', type = 'website', noIndex = false }) {
  const { lang } = useLanguage();
  const langPrefix = lang === 'es' ? '/es' : '';
  const cleanPath = path === '/' ? '' : path;
  const fullUrl = `${SITE_URL}${langPrefix}${cleanPath}`;
  const altUrl = `${SITE_URL}${lang === 'es' ? '' : '/es'}${cleanPath}`;
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Strength Coaching`;

  return (
    <Helmet>
      {/* Basic */}
      <html lang={lang} />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullUrl} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      {/* Hreflang for language alternates */}
      <link rel="alternate" hrefLang="en" href={`${SITE_URL}${cleanPath || '/'}`} />
      <link rel="alternate" hrefLang="es" href={`${SITE_URL}/es${cleanPath}`} />
      <link rel="alternate" hrefLang="x-default" href={`${SITE_URL}${cleanPath || '/'}`} />

      {/* Open Graph */}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content={lang === 'es' ? 'es_ES' : 'en_US'} />
      <meta property="og:locale:alternate" content={lang === 'es' ? 'en_US' : 'es_ES'} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OG_IMAGE} />

      {/* Apple */}
      <meta name="apple-mobile-web-app-title" content={SITE_NAME} />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
    </Helmet>
  );
}
